import RoutesMap from "../../route_control/RouteControl"
import { lazy } from "react"
import {
    AddBrand,
    UpdateBrand,
    BrandList,
    CategoryList,
    AddCategory,
    UpdateCategory,
    AddVendor,
    UpdateVendor,
    VendorList,
    SubCategoryList,
    AddSubCategory,
    UpdateSubCategory,
    ItemList,
    AddItem,
    UpdateItem,
    AddSpareParts,
    UpdateSpareParts,
    SparePartsList,
    AddTools,
    UpdateTools,
    ToolsList,
    DepartmentList,
    AddDepartment,
    UpdateDepartment,
    ServiceDepartmentList,
    AddServiceDepartment,
    UpdateServiceDepartment,
    AddBlock,
    UpdateBlock,
    BlockList,
    AddLocation,
    UpdateLocation,
    LocationList,
    AddSubLocation,
    UpdateSubLocation,
    SubLocationList,
    ShiftList,
    AddShift,
    UpdateShift,
    SlaAndPriorityList,
    AddSlaAndPriority,
    UpdateSlaAndPriority,
    TaskStatusList,
    AddTaskStatus,
    UpdateTaskStatus,
    ReasonList,
    AddReason,
    UpdateReason,
    StaffList,
    AddStaff,
    UpdateStaff,
    CityList,
    InventoryUnitList,
    AddInventoryUnit,
    UpdateInventoryUnit,
    CountryList,
    StateList,
    MasterChecklistList,
    AddMasterChecklist,
    UpdateMasterChecklist,
} from "../../pages/master"

const AddItemCategory = lazy(() => import("../../pages/master/item_category/AddItemCategory"))
const UpdateItemCategory = lazy(() => import("../../pages/master/item_category/UpdateItemCategory"))
const ItemCategoryList = lazy(() => import("../../pages/master/item_category/ItemCategoryList"))
const SkillMatrixList = lazy(() => import("../../pages/master/skill_matrix/SkillMatrixList"))
const AddSkillMatrix = lazy(() => import("../../pages/master/skill_matrix/AddSkillMatrix"))
const UpdateSkillMatrix = lazy(() => import("../../pages/master/skill_matrix/UpdateSkillMatrix"))

export const AssetMasterRouteImport = {
    RoutesMap,
    AddCategory,
    UpdateCategory,
    CategoryList,
    AddBlock,
    UpdateBlock,
    BlockList,
    AddLocation,
    UpdateLocation,
    LocationList,
    AddSubLocation,
    UpdateSubLocation,
    SubLocationList,
    AddDepartment,
    UpdateDepartment,
    DepartmentList,
    AddServiceDepartment,
    UpdateServiceDepartment,
    ServiceDepartmentList,
    AddItemCategory,
    UpdateItemCategory,
    ItemCategoryList,
    AddItem,
    UpdateItem,
    ItemList,
    AddVendor,
    UpdateVendor,
    VendorList,
    AddBrand,
    BrandList,
    UpdateBrand,
    SkillMatrixList,
    AddSkillMatrix,
    UpdateSkillMatrix,
    AddInventoryUnit,
    UpdateInventoryUnit,
    InventoryUnitList,
    TaskStatusList,
    AddTaskStatus,
    UpdateTaskStatus,
    SlaAndPriorityList,
    AddSlaAndPriority,
    UpdateSlaAndPriority,
    AddStaff,
    UpdateStaff,
    StaffList,
    SubCategoryList,
    AddSubCategory,
    UpdateSubCategory,
    AddSpareParts,
    UpdateSpareParts,
    SparePartsList,
    AddTools,
    UpdateTools,
    ToolsList,
    AddShift,
    UpdateShift,
    ShiftList,
    ReasonList,
    AddReason,
    UpdateReason,
    CityList,
    CountryList,
    StateList,
    MasterChecklistList,
    AddMasterChecklist,
    UpdateMasterChecklist,
}